/**
 * Detect whether an error is related to an Encompass file lock.
 * Accepts unknown input and safely normalizes Error objects,
 * Axios-style responses, and raw strings.
 */
export function isLockRelatedError(error: unknown): boolean {
  const patterns = [
    /\b(409|423)\b/,
    /locked|being modified|exclusive/i,
    /loan\.locked|resource\.locked/i
  ];

  const candidates: string[] = [];

  if (typeof error === 'string') {
    candidates.push(error);
  } else if (error instanceof Error) {
    candidates.push(error.message);
  }

  if (error && typeof error === 'object') {
    const obj = error as Record<string, unknown>;
    if (obj.response && typeof obj.response === 'object') {
      const response = obj.response as Record<string, unknown>;
      if (typeof response.status === 'number' && (response.status === 409 || response.status === 423)) {
        return true;
      }
      if (typeof response.data === 'string') {
        candidates.push(response.data);
      } else if (response.data && typeof response.data === 'object') {
        const data = response.data as Record<string, unknown>;
        for (const field of ['error', 'summary', 'message', 'code', 'errorCode']) {
          if (typeof data[field] === 'string') {
            candidates.push(data[field]);
          }
        }
      }
    }

    for (const field of ['error', 'message', 'code', 'errorCode']) {
      if (typeof obj[field] === 'string' && (field !== 'message' || !(error instanceof Error))) {
        candidates.push(obj[field]);
      }
    }
  }

  return candidates.some(text => patterns.some(pattern => pattern.test(text)));
}
